class s extends Error {
  constructor(e) {
    super(), this.name = this.constructor.name, this.redirect = e;
  }
}
export {
  s as AccessDenied
};
